import { Logout, Person } from "@mui/icons-material";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { FC, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { useAuthActions, useSimpleNavigation } from "@ryde/redux";
import { isLoggedInAtom, Log } from "@ryde/shared";

interface ILeftBarProfilePopup {
  handleMenuClose?: () => void;
}

export const LeftBarProfileContext: FC<ILeftBarProfilePopup> = ({
  handleMenuClose,
}) => {
  const { t } = useTranslation();
  const { handleLogout } = useAuthActions();
  const { navigateLogin, navigateProfile } = useSimpleNavigation();
  const isLoggedIn = useRecoilValue(isLoggedInAtom);

  useEffect(() => {
    if (!isLoggedIn) {
      Log.debug("User logged out, navigating to login");
      navigateLogin();
    }
  }, [isLoggedIn, navigateLogin]);

  const handleLogoutClick = useCallback(() => {
    handleLogout();
    handleMenuClose?.();
  }, [handleMenuClose, handleLogout]);

  const handleProfileClick = useCallback(() => {
    navigateProfile();
    handleMenuClose?.();
  }, [handleMenuClose, navigateProfile]);

  return (
    <>
      <MenuItem data-e2e="nav-open-profile" onClick={handleProfileClick}>
        <ListItemIcon>
          <Person fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t(`general.PROFILE`)}</ListItemText>
      </MenuItem>
      <MenuItem data-e2e="nav-logout" onClick={handleLogoutClick}>
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t(`general.LOGOUT`)}</ListItemText>
      </MenuItem>
    </>
  );
};
